import React, { useEffect } from 'react';
import { Row, Col, Image } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { fetchPasses } from '../redux/actions/productActions';
import { getPassByGroup } from '../lib/product';
import LayoutWithSideBar from '../components/LayoutWithSideBar';
import productData from "../data/product.json";

const PassTypes = ({ passes, fetchPasses }) => {

  useEffect(() => {
    fetchPasses();
  }, [fetchPasses])

  let { gym, pass } = useParams();

  const filteredPass = getPassByGroup(passes, pass.replace(/[-]+/g, ' ').replace(/(^\w{1})|(\s+\w{1})/g, (c) => c.toUpperCase()), gym.replace(/-/g, " ").toLowerCase());
  const passType = Object.keys(filteredPass).sort();

  if (!passes || Object.keys(passes).length === 0) {
    return (
      <LayoutWithSideBar>
        <div className="text-center"><h3>Loading...</h3></div>
      </LayoutWithSideBar>
    );
  }

  return (
    <LayoutWithSideBar>
      {passType && passType.length > 0 ? (
        passType.map((type, i) => {
          /* const style = {
            backgroundImage: 'url(\'/assets/images/passes/' + gym + '-' + type.toLowerCase() + '.png\')'
          }; */
          const gymKey = gym?.toLowerCase();
          const passKey = pass?.toLowerCase().replace(/_/g, '-');
          const typeKey = type?.toLowerCase().replace(/[\s-]/g, '_');

          let description = productData.passTypes[gymKey]?.[passKey]?.[typeKey];

          if (!description && productData.passTypes[gymKey]) {
            for (const category in productData.passTypes[gymKey]) {
              if (productData.passTypes[gymKey][category][typeKey]) {
                description = productData.passTypes[gymKey][category][typeKey];
                break;
              }
            }
          }

          if (!description) {
            const passData = filteredPass[type]?.[0];
            if (passData && passData.variants && passData.variants.length > 0) {
              description = passData.variants[0].desc;
            }
          }

          return (
            <Row key={i} className="space-pb-30 align-items-center">
              <Col md={5} sm={12}>
                <Link to={`/online_ticket/${gym}/${pass}/${type}`}>
                  <Image
                    src={`/assets/images/passes/${gym}-${type.toLowerCase()}.png`}
                    alt={`${pass} ${type}`}
                    className="pass-types"
                    fluid
                  />
                </Link>
              </Col>
              <Col md={7} sm={12} className="space-mt-10">
                <Col xl={9} lg={10} md={12}>
                  <p className="pass-description" style={{ textAlign: "justify" }}>
                    {description}
                  </p>
                </Col>
              </Col>
            </Row>
          )
        })
      ) : (
        <div className="text-center">
          <h3>No ticket available for {pass.replace(/[-]+/g, ' ')} now.</h3>
          <p>Please stay tuned for updates!</p>
        </div>
      )}
    </LayoutWithSideBar>
  )
}

const mapStateToProps = (state) => {
  return {
    passes: state.productData.passes
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchPasses: () => {
      dispatch(fetchPasses());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PassTypes);